import SalesTable from "pages/sales/components/SalesTable";

export default function FinanceSalesPage() {
  return (
    <>
      <h2 className="text-lg font-medium text-gray-900 mb-4">Sales</h2>
      <SalesTable />
    </>
  );
}
